import { Separator } from '@cox/core-ui8/dist/Separator'

import { ReactSeparatorProps } from './types'
import withAEM from '../../hoc/withAEM'

const ReactSeparator = (props: ReactSeparatorProps): JSX.Element => {
  const SeperatorWithAEM = withAEM(Separator)
  return <SeperatorWithAEM {...props} compName={'Seperator'} className={'py-5 px-6 px-md-12 px-xl-18'} />
}
export default ReactSeparator
